var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup",class:{ show: _vm.visible },on:{"transitionend":_vm.destroyPopup}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }